import React from 'react'

import { fromJS } from 'immutable'

import { GetCustomerCopyFunc } from '@lyrahealth-inc/shared-app-logic'

import { excludedServicesNotice } from './defaultWithoutMeds'
import { CoverageNotice } from '../atoms/coverageNotice/CoverageNotice'

export const netapp: GetCustomerCopyFunc = ({ numberOfSessions }) => {
  return fromJS({
    legalNotice: <CoverageNotice excludedServices={excludedServicesNotice} sessionLimit={numberOfSessions} />,
  })
}
